import { Box, Container, Grid, Typography } from "@mui/material";

import { ReactComponent as CreateAccountSvg } from "assets/images/homepage/create_account.svg";
import { ReactComponent as IntuitiveSvg } from "assets/images/homepage/intuitive.svg";
import { ReactComponent as PerformanceSvg } from "assets/images/homepage/performance.svg";
import { ReactComponent as PrimerDesignSvg } from "assets/images/homepage/primer_design.svg";
import { Acronym, AMP, NGS, PCR } from "components/acronyms";
import { colors } from "theme";

import { KeyFeature } from "./KeyFeature";
import { KeyFeatureProps } from "./type";

const KeyFeatureItems: KeyFeatureProps[] = [
  {
    title: "Expert Primer Design",
    content: (
      <>
        Primer design is the foundation of <NGS />
        -based panel performance. Our in-house experts leverage the flexibility
        of Anchored Multiplex <PCR /> (<Acronym text="AMP" />
        ™) chemistry and purpose-built algorithms to ensure our panels achieve
        consistent primer performance, specificity and coverage with the
        intended input material.
      </>
    ),
    FeatureImage: PrimerDesignSvg,
  },
  {
    title: "Simple and Intuitive",
    content: (
      <>
        Assay Marketplace has a simple, intuitive interface that will quickly
        suggest the optimal panel based on your gene list using our large
        catalog of functionally tested designs.
      </>
    ),
    FeatureImage: IntuitiveSvg,
  },
  {
    title: "Exceptional Performance",
    content: (
      <>
        <AMP /> primers function independently, meaning new content can be added
        to existing panels without compromising assay performance. Our custom
        panel solutions offer maximum flexibility and unparalleled performance
        so you can be confident that your targets will be covered.
      </>
    ),
    FeatureImage: PerformanceSvg,
  },
  {
    title: "Full Support",
    content:
      "With Designer Pro, your panel is iteratively designed and functionally tested in the lab. From target curation to data reviews, panel configuration, training and post launch support, we’ve got you covered.",
    FeatureImage: CreateAccountSvg,
  },
];

export const KeyFeatures = () => (
  <Box
    component="section"
    bgcolor={colors.white}
    pt={{ xs: 3, sm: 4, md: 5, lg: 10 }}
    pb={{ xs: 4, sm: 5, md: 7, lg: 12 }}
  >
    <Container>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        rowGap={{ xs: "18px", sm: 3, md: 4 }}
        position="relative"
        margin="auto"
      >
        <Typography variant="h1" component="h2" align="center">
          Key Features
        </Typography>
        <Grid container spacing={3} justifyContent="center" component="ul">
          {KeyFeatureItems.map((item: KeyFeatureProps, index: number) => (
            <Grid item xs={12} sm={6} md={3} key={index} component="li">
              <KeyFeature {...item} />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  </Box>
);
